class _RouteLinks {
  public LayoutHome = '/admin/';
  public Dashboard = '/admin/dashboard/';
  public AuthLogin = `/auth/login/`;
  public Users = `${this.LayoutHome}users/`;
}

export const RouteLinks = new _RouteLinks();
